import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { XCircle, Save } from "react-feather";
import { useForm } from "react-hook-form";
import { GET, POST, PUT, FILE } from "../../../api/adminApi";
import { toast } from "react-toastify";

export default function NewsCreateUpdate() {
  const { id } = useParams();
  const history = useHistory();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: "",
      text: "",
      photo: "",
      thumbPhoto: "",
    },
  });

  const [data, setData] = useState({
    title: "",
    text: "",
    photo: "",
    thumbPhoto: "",
  });

  async function create(values) {
    const body = {
      ...values,
      id: id ? id : 0,
      photo: data.photo,
      thumbPhoto: data.thumbPhoto,
    };

    let response;
    if (id) {
      response = await PUT("/services/admin/api/news", body);
    } else {
      response = await POST("/services/admin/api/news", body);
    }

    if (response && response.success) {
      toast.success(id ? "Успешно обновлено" : "Успешно создано");
      history.push("/admin/news");
    } else {
      // Error handling usually in adminApi or show toast
    }
  }

  const getData = React.useCallback(async () => {
    const response = await GET("/services/admin/api/news/" + id);
    if (response) {
      setValue("title", response.title);
      setValue("text", response.text);
      setValue("photo", response.photo);
      setValue("thumbPhoto", response.thumbPhoto);
      setData(response);
    }
  }, [id, setValue]);

  // Reusable function to handle both photo and thumbPhoto uploads
  async function handleFileUpload(e, fieldName) {
    if (e.target.files[0]) {
      const image = e.target.files[0];
      const formData = new FormData();
      formData.append("image", image);
      try {
        const response = await FILE(
          "/services/admin/api/news-image-upload",
          formData,
        );
        let url = response?.url;
        // Fallback in case the API returns the string directly
        if (!url && typeof response === "string") {
          url = response;
        }

        if (url) {
          setData((prev) => ({ ...prev, [fieldName]: url }));
          setValue(fieldName, url);
        }
      } catch (err) {
        console.error(err);
      }
    }
  }

  useEffect(() => {
    if (id) {
      getData();
    }
  }, [id, getData]);

  return (
    <div className="mb-2 mx-3 ">
      <h3 className="mb-5 mt-5">{id ? "Изменить" : "Добавить новый"}</h3>
      <div className="admin-card py-4">
        <form onSubmit={handleSubmit(create)} autoComplete="off">
          <div className="d-flex pt-12">
            {/* Left Column for Images */}
            <div className="" style={{ width: "300px" }}>
              {/* Main Photo Field */}
              <div className="admin-field mb-5">
                <div className="d-flex w-100">
                  <div className="admin-label mr-md-3">
                    <label className="mb-0">Фото</label>
                  </div>
                  <div className="position-relative">
                    <div
                      className="image-block"
                      style={{
                        width: "200px",
                        minWidth: "100px",
                        minHeight: "200px",
                        border: "1px dashed #D4D3D6",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        padding: "10px",
                      }}
                    >
                      Перетащите сюда файлы для загрузки
                    </div>
                    <input
                      onChange={(e) => handleFileUpload(e, "photo")}
                      type="file"
                      placeholder=""
                      style={{
                        width: "200px",
                        minWidth: "100px",
                        minHeight: "200px",
                        opacity: "0",
                        top: 0,
                        zIndex: 3,
                        position: "absolute",
                      }}
                      className="cursor border border-radius-3 box outline-none color-grey"
                    />
                    {data.photo && (
                      <div
                        className="position-absolute cursor border-radius-3"
                        style={{
                          width: "200px",
                          minWidth: "100px",
                          minHeight: "200px",
                          top: 0,
                          zIndex: 2,
                        }}
                      >
                        <img
                          className="w-100 h-100 background-white border box-shadow"
                          src={
                            data.photo.startsWith("http")
                              ? data.photo
                              : "https://api-club.akfacomfort.uz" + data.photo
                          }
                          alt="Main"
                          style={{ objectFit: "cover" }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Thumb Photo Field */}
              <div className="admin-field">
                <div className="d-flex w-100">
                  <div className="admin-label mr-md-3">
                    <label className="mb-0">Превью</label>
                  </div>
                  <div className="position-relative">
                    <div
                      className="image-block"
                      style={{
                        width: "150px",
                        minWidth: "100px",
                        minHeight: "150px",
                        border: "1px dashed #D4D3D6",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        padding: "10px",
                        fontSize: "13px",
                      }}
                    >
                      Загрузить миниатюру
                    </div>
                    <input
                      onChange={(e) => handleFileUpload(e, "thumbPhoto")}
                      type="file"
                      placeholder=""
                      style={{
                        width: "150px",
                        minWidth: "100px",
                        minHeight: "150px",
                        opacity: "0",
                        top: 0,
                        zIndex: 3,
                        position: "absolute",
                      }}
                      className="cursor border border-radius-3 box outline-none color-grey"
                    />
                    {data.thumbPhoto && (
                      <div
                        className="position-absolute cursor border-radius-3"
                        style={{
                          width: "150px",
                          minWidth: "100px",
                          minHeight: "150px",
                          top: 0,
                          zIndex: 2,
                        }}
                      >
                        <img
                          className="w-100 h-100 background-white border box-shadow"
                          src={
                            data.thumbPhoto.startsWith("http")
                              ? data.thumbPhoto
                              : "https://api-club.akfacomfort.uz" +
                                data.thumbPhoto
                          }
                          alt="Thumb"
                          style={{ objectFit: "cover" }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column for Text Inputs */}
            <div className="" style={{ width: "500px" }}>
              <div className="admin-field">
                <div className="d-flex w-100">
                  <div className="admin-label mr-md-3">
                    <label className="mb-0">Заголовок</label>
                  </div>
                  <input
                    {...register("title", { required: true })}
                    placeholder=""
                    className="input-control"
                  />
                </div>
                {errors.title && (
                  <div className="text-danger mt-1 fz12">Обязательное поле</div>
                )}
              </div>
              <div className="admin-field">
                <div className="d-flex w-100">
                  <div className="admin-label mr-md-3">
                    <label className="mb-0">Текст</label>
                  </div>
                  <textarea
                    {...register("text", { required: true })}
                    placeholder=""
                    className="input-control"
                    rows={5}
                  />
                </div>
                {errors.text && (
                  <div className="text-danger mt-1 fz12">Обязательное поле</div>
                )}
              </div>
            </div>
          </div>
          <div className="btn-postion d-flex mt-5">
            <Link to="/admin/news" className="mr-3">
              <button className="btn text-white btn-bg-primary d-flex align-items-center">
                <XCircle size={14} className="mr-2" />
                Отмена
              </button>
            </Link>
            <button
              className="btn text-white btn-bg-success d-flex align-items-center"
              type="submit"
            >
              <Save size={14} className="mr-2" />
              Сохранить
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
